module.exports = __webpack_public_path__ + "img/checkout-done.1610dda2.png";